/**
 * Rewrite a Cloudinary secure_url to include an overlay watermark.
 * - Only applies to Cloudinary URLs (starts with res.cloudinary.com).
 * - Inserts transformation params right after `/upload/`.
 * - overlayPublicId uses ':' instead of '/' (e.g., 'brand:mna_watermark').
 *
 * Default: 55% wide relative to base image, 22% opacity, centered.
 */
export function watermarked(
  url,
  {
    overlay = "brand:mna_watermark",
    width = 0.55,
    opacity = 22,
    gravity = "center",
  } = {}
) {
  if (!url || typeof url !== "string") return url;
  if (!url.includes("res.cloudinary.com")) return url;
  const marker = "/upload/";
  const idx = url.indexOf(marker);
  if (idx === -1) return url;

  const transform = `l_${overlay},w_${width},fl_relative,o_${opacity},g_${gravity}`;
  return url.slice(0, idx + marker.length) + transform + "/" + url.slice(idx + marker.length);
}
